// removed by extract-text-webpack-plugin
module.exports = {"statusIndicator":"statusIndicator___o30YJ","active":"active___tK9VW","idle":"idle___3S2tO","off":"off___3ebrN","dnd":"dnd___2cqJP","avatar":"avatar____C13d","capitals":"capitals___3jmYZ","illustration":"illustration___87hGT","img":"img___1hdB1","small":"small___2Rb1P avatar____C13d","short":"short___n9jNs avatar____C13d","medium":"medium___2WtnN avatar____C13d","grande":"grande___1KBaF avatar____C13d","big":"big___KBJMM avatar____C13d","url":"url___26FBP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/index.scss
// module id = 72
// module chunks = 0